import React, { useState, useEffect } from 'react';
import { ReactComponent as UploadFileIcon } from '../../../../assets/images/upload_file.svg';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Container, MenuItem, TextField, Typography, Paper, Input, Grid, IconButton, LinearProgress } from '@mui/material';
import {useSelector, useDispatch} from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';

import {
  // fetchDocumentManagement,
  docSubType,
  scanDocumentManagement,
  resetToast
} from '../../../../redux/reducers/DocumentManagement';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    position: 'relative',
  },
  title: {
    "&&": {
      fontFamily: '"articulat-cf", sans-serif !important',
      fontStyle: 'normal',
      fontSize: '18px',
      fontWeight: 600,
      lineHeight: '28px',
      textAlign: 'left',
      color: '#000000DE',
    }
  },
  subTitle: {
    "&&": {
      fontFamily: '"articulat-cf", sans-serif !important',
      fontStyle: 'normal',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '28px',
      textAlign: 'left',
      color: '#000000DE',
    }
  },
  customInput: {
    marginTop: '10px',
    marginBottom: '10px',
  },
  textField: {
    width: '100%',
  },
  textFieldError: {
    '&&': {
      border: '1px solid red',
    },
  },
  cancelButton: {
    '&&': {
      color: '#01579B',
      border: '1px solid #01579B',
      marginRight: '10px',
      textTransform: 'none',
      '&:hover': {
        color: '#FFF',
        backgroundColor: '#01579B',
        borderRadius: '5px',
      },
    },
  },
  saveButton: {
    '&&': {
      color: '#FFF',
      background: '#0288D1',
      border: '1px solid #0288D1',
      textTransform: 'none',
      '&:hover': {
        color: '#0288D1',
        backgroundColor: '#FFF',
        borderRadius: '5px',
      },
    },
  },
  uploadArea: {
    '&&': {
      fontFamily: '"articulat-cf", sans-serif !important',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(2),
      cursor: 'pointer',
      width: '100%',
      gap: theme.spacing(1),
      fontSize: '13px',
      fontWeight: 600,
      lineHeight: '22px',
      letterSpacing: '0.02em',
      marginTop: '20px',
      textAlign: 'center',
      padding: '24px 16px',
      gap: '8px',
      '&.dragover': {
        backgroundColor: '#e3f2fd', 
        borderColor: '#42a5f5', 
      },
    },
  },
  toolTip: {
    "&&": {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#0000008A',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.17px',
    }
  },
  dragAndDropFont: {
    "&&": {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#000000DE',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '28px',
      letterSpacing: '0.15px',
    }
  },
  progressContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
  },
  progressText: {
    marginLeft: theme.spacing(1),
  },
  deleteIcon: {
    cursor: 'pointer',
  },
  dragAndDrop: {
    "&&": {
      color: '#1E88E5',
      textDecoration: 'underline',
      fontWeight: 700,
      fontFamily: '"articulat-cf", sans-serif !important',
    }
  },
  helperText: {
    "&&": {
      fontWeight: 400,
      fontSize: '0.75rem',
      lineHeight: 1.66,
      textAlign: 'left',
      marginTop: '4px',
      marginRight: '14px',
      marginBottom: 0,
      marginLeft: '14px',
    }
  },
  helperTextLoading: {
    "&&": {
      color: '#0000008A',
      fontFamily: '"articulat-cf", sans-serif !important',
      fontSize: '14px',
      fontWeight: 600,
      lineHeight: '20px',
      letterSpacing: '0.17px'
    }
  },
  fileLoadingText: {
    "&&": {
      fontFamily: '"articulat-cf", sans-serif !important',
      color: '#3B4149',
      fontSize: '16px',
      fontWeight: 600,
      lineHeight: '20px',
      letterSpacing: '0.15px',
      fontStyle: 'normal',
      textAlign: 'left',
    }
  },
  selectedItemText: {
    "&&": {
      color: '#A9B0BB',
      fontFamily: '"articulat-cf", sans-serif !important',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0.15px',
    }
  }
}));

const AddFile = ({ accountId, handleCloseModal, action, fileLoaded }) => {
  const dispatch = useDispatch();

  const { dropDownData,  subType, errorMsg, successMsg } = useSelector(
    ({documentManagement}) => documentManagement,
  );

  // TODO: Add validation schema here using yup library for form validation 
  // Validation schema for form validation manually because yupResolver is not working with react-hook-form v5 and mui5 using select component
  const [errors, setErrors] = useState({
    company: { isError: false, message: '' },
    fileType: { isError: false, message: '' },
    fileObject: { isError: false, message: '' },
  });

  const [companyArray, setCompanyArray] = useState([]);
  const [fileTypeArray, setFileTypeArray] = useState([]);

  const [company, setCompany] = useState('');
  const [fileType, setFileType] = useState('');
  const [description, setDescription] = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    if (dropDownData && dropDownData.DOC_TYPE) {
      const transformedArray = dropDownData.DOC_TYPE.map(item => ({
        companyId: item.id,
        companyValue: item.valueCode,
        companyLabel: item.value,
      }));
      setCompanyArray(transformedArray);
      setCompany('');
      setFileType('');
      setFileTypeArray([]);
    }
  }, [dropDownData]);

  useEffect(() => {
    if (subType) {
      const transformedArray = subType.map(item => ({
        fileTypeId: item.valueCode,
        fileTypeValue: item.value 
      }));
      if(company != ''){
        setFileTypeArray(transformedArray);
        setFileType('');
      }
    }else {
      setFileType('');
    }
  }, [subType]); 

  useEffect(() => {
    if (fileTypeArray.length == 1) {
      setFileType(fileTypeArray[0].fileTypeValue);
    }else {
      setFileType('');
    }
  }, [fileTypeArray]); 

  const classes = useStyles();

  const [newFile, setNewFile] = useState(null);
  const [fileSize, setFileSize] = useState(0);
  const [fileObject, setFileObject] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  
  useEffect(() => {
    if(fileObject){
      setErrors({ ...errors, 
        fileObject: { isError: !fileObject ? true : false, message: !fileObject ? 'File is required' : '' }
      });
    }
    if(company){
      setErrors({ ...errors, 
        company: { isError: !company ? true : false, message: !company ? 'Company is required' : '' }, 
      });
    }
    if(fileType){
      setErrors({ ...errors, 
        fileType: { isError: !fileType ? true : false, message: !company ? 'File type is required' : '' },
      });
    }
  }, [fileObject, company, fileType]); 

  const handleFileChange = (event) => {
    uploadFile(event.target.files[0]);
  };

  const uploadFile = (selectedFile) => {
    if (selectedFile) {
      const { size, name } = selectedFile;
      const fileExtension = name.split('.').pop().toLowerCase();
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'docx', 'doc', 'txt'];

      if (!allowedExtensions.includes(fileExtension)) {
        setErrors({ ...errors, 
          fileObject: { isError: true, message: 'File type is not allowed' }
        });
        return;
      }

      if (size > 5 * 1024 * 1024) { 
        setErrors({ ...errors, 
          fileObject: { isError: true, message: 'File is too large' }
        });
        return;
      }
      setFileObject(selectedFile);
      setNewFile(selectedFile.name);
      setFileSize((selectedFile.size / 1024).toFixed(2));
    } else {   
      setNewFile(null);
      setFileSize(0);
    }
  }

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const newFile = event.dataTransfer.files[0];
    if (newFile) {
      setFileObject(newFile);
      setNewFile(newFile.name);
      setFileSize((newFile.size / 1024).toFixed(2));
    }
  };

  const handleCompanyChange = (newValue) => {
    setCompany(newValue)
    dispatch(docSubType({
      parentValueCode: newValue,
      childTypeCode: 'SUB_DOC_TYPE',
    }));
    if (newValue) {
      setErrors({ ...errors, company: { isError: false, message: '' } });
    }
  };

  const removeFile = () => {
    setFileObject(null);
    setNewFile(null);
    setFileSize(0);
  };

  const handleFileUpload = () => {
    const totalTime = 1000; 
    const updateInterval = 10; 
    const increment = (updateInterval / totalTime) * 100; 

    let progress = 0; 
    const interval = setInterval(() => {
      progress += increment;
      if (progress >= 100) {
        clearInterval(interval);
        setUploadProgress(100); 
      } else {
        setUploadProgress(progress);
      }
    }, updateInterval);
  };
  
  useEffect(() => {
    if (fileObject) {
      handleFileUpload();
    }
  }, [fileObject]); 

  useEffect(() => {
    if (fileLoaded) {
      uploadFile(fileLoaded);
    }
  }, []);

  const onSubmit = data => {
    if(!company || !fileType || !fileObject) {
      setErrors({ ...errors, 
        company: { isError: !company ? true : false, message: !company ? 'Company is required' : '' }, 
        fileType: { isError: !fileType ? true : false, message: !fileType ? 'File type is required' : '' },
        fileObject: { isError: !fileObject ? true : false, message: !fileObject ? 'File is required' : '' }
      });
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(fileObject);
    reader.onload = () => {
      dispatch(scanDocumentManagement({
        file: reader.result.split(',')[1],
        fileName: newFile,
        accountNumber: accountId,
        documentDescription: description,
        documentType: company,
        documentSubtype: fileType
      }, accountId));
      resetForm();
      setTimeout(() => {
        dispatch(resetToast());
      }, 5000);
    }
  };

  const resetForm = () => {
    setCompany('');
    setFileType('');
    setDescription('');
    setUploadProgress(0);
    setNewFile(null);
    setFileSize(0);
    setIsDragging(false);
    setFileObject([]);
  };
  
  return (
    <div className="row">
      <Container maxWidth="sm">
        <Typography className={classes.title}>
          Upload a File
        </Typography>
        <Typography className={classes.subTitle}>
          Select the company and newFile type for your upload
        </Typography>
        <form>
          <Grid container sx={{ width: '100%' }}>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={4} sx={{ marginRight: '10px', marginTop: '10px' }}>
              <TextField
                onChange={(e) => {handleCompanyChange(e.target.value)}}
                select
                name="company"
                value={company}
                id="company"
                label="Company*"
                error={!!errors.company.isError}
                helperText={errors.company.isError ? errors.company.message : ''}
                fullWidth
                size="small"
                InputLabelProps={{ shrink: true }}
                sx={{ marginRight: '10px'}}
              >
                <MenuItem key="select-company" value="" disabled><span className={classes.selectedItemText}>Select</span></MenuItem>
                {companyArray.map((item) => (
                  <MenuItem key={item.companyId} value={item.companyValue}>{item.companyLabel}</MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} xl={6} sx={{ marginTop: '10px' }}>
              <TextField
                select
                name="fileType"
                value={fileType}
                id="fileType"
                label="File Type*"
                error={!!errors.fileType.isError}
                helperText={errors.fileType.isError ? errors.fileType.message : ''}
                fullWidth
                onChange={(e) => {setFileType(e.target.value);setErrors({ ...errors, fileType: { isError: false, message: '' } });}}
                size="small"
                InputLabelProps={{ shrink: true }}
              >
                <MenuItem key="select-filetype" value="" disabled> <span className={classes.selectedItemText}>Select</span> </MenuItem>
                {fileTypeArray.map((item) => (
                  <MenuItem key={item.fileTypeId} value={item.fileTypeValue}>
                    {item.fileTypeValue}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ marginTop: '10px', marginBottom: '15px' }}>
              <TextField
                name="description"
                id="description"
                value={description}
                fullWidth
                variant="outlined"
                size="small"
                label="Description"
                InputLabelProps={{ shrink: true }}
                multiline
                onChange={(e) => {setDescription(e.target.value)}}
                rows={1}
              />
            </Grid>
          </Grid>
          <div
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {!newFile ? (
              <label
                htmlFor="new-file-upload"
                style={{ width: '100%', alignItems: 'center' }}
              >
                <Paper 
                  className={`${classes.uploadArea} ${isDragging ? 'dragover' : ''}`}
                  sx={{
                    border: errors.fileObject.isError ? '2px dashed red' : '2px dashed #C5CBD499'
                  }}
                >
                  <UploadFileIcon style={{ color: '#1E88E5' }} />
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography
                      variant="body2"
                      className={classes.dragAndDrop}
                    >
                      Click to upload
                    </Typography>
                    <Typography className={classes.dragAndDropFont}>&nbsp;or drag and drop here.</Typography>
                  </div>
                  <Typography className={classes.toolTip}>jpg, jpeg, png, pdf, docx, doc, txt (max. 5MB)</Typography>
                </Paper>
                <Typography color="error" className={classes.helperText}>
                  {errors.fileObject.isError && errors.fileObject.message}
                </Typography>
                <Input
                  sx={{ display: 'none' }}
                  accept="*/*"
                  id="new-file-upload"
                  type="file"
                  className={classes.input}
                  onChange={handleFileChange}
                />
              </label>
            ) : (
              <>
                {uploadProgress < 100 ? (
                  <Paper
                    component="div"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      p: 1,
                      bgcolor: 'background.paper',
                      boxShadow: 1,
                      borderRadius: '4px',
                    }}
                  >
                    <Grid container sx={{ width: '100%' }}>
                      <Grid item xs={1} sm={1} md={1} lg={1} xl={1} sx={{  alignContent: 'center', textAlign: 'center' }}>
                        <UploadFileIcon style={{ color: '#1E88E5' }} />
                      </Grid>
                      <Grid item xs={10} sm={10} md={10} lg={10} xl={10} sx={{  alignContent: 'center', textAlign: 'left' }}>
                        <Typography variant="body2" className={classes.fileLoadingText} >{ newFile }</Typography>
                        <Typography className={classes.helperTextLoading} variant="body2">{ fileSize }kb • Loading</Typography>
                        <LinearProgress variant="determinate" value={uploadProgress} sx={{ width: '200px', marginTop: '8px' }} />
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} lg={1} xl={1} sx={{  alignContent: 'center', textAlign: 'center' }}>
                        <IconButton size="small" onClick={removeFile}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Paper>
                ) : (
                  <Paper
                    component="div"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      p: 1,
                      bgcolor: 'background.paper',
                      boxShadow: 1,
                      borderRadius: '4px',
                    }}
                  >
                    <Grid container sx={{ width: '100%' }}>
                      <Grid item xs={1} sm={1} md={1} lg={1} xl={1} sx={{  alignContent: 'center', textAlign: 'center', color: 'rgb(156, 230, 30)' }}>
                        <CheckCircleOutlineIcon />
                      </Grid>
                      <Grid item xs={10} sm={10} md={10} lg={10} xl={10} sx={{  alignContent: 'center', textAlign: 'left' }} >
                        <Typography variant="body2" className={classes.fileLoadingText}>{ newFile }</Typography>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} lg={1} xl={1} sx={{  alignContent: 'center', textAlign: 'center' }}>
                        <IconButton size="small" onClick={removeFile}>
                          <DeleteIcon />
                        </IconButton>
                      </Grid>
                    </Grid>
                  </Paper>
                )}
              </>
            )}
          </div>
          <Box display="flex" justifyContent="flex-end" sx={{ marginTop: '10px' }}>
            <Button
              type="button"
              color="inherit"
              size="medium"
              className={classes.cancelButton}
              onClick={(e) => {
                e.stopPropagation();
                handleCloseModal(action);
              }}
            >
              Cancel
            </Button>
            <Button type="button" color="inherit" size="medium" onClick={onSubmit} className={classes.saveButton}>
              Save
            </Button>
          </Box>
        </form>
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </Container>
    </div>
  );
};

export default AddFile;
